import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const EnvironmentDayCelebration2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/Environment/7.webp`;

  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},



  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Environment Day
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Classes: Montessori – I, II, III      Date: 25 June 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
he Earth has its music for those who will listen
<br></br>
        </Typography>


        <Typography variant={'subtitle1'} align={'justify'}>
      On 25th June 2026, ‘Environment Day’ was celebrated with great enthusiasm in Montessori. The children participated in various eco-friendly activities to learn the importance of protecting our environment.
      <br></br>
Montessori I children enjoyed a creative art activity by Sticking Bottle Caps to make a beautiful butterfly and a flower model. Through this activity, they learned about reusing waste materials in a fun and artistic way.
<br></br>

Montessori II children took part in a Waste segregation activity, where they learned to identify and separate biodegradable and non-biodegradable waste materials. This activity helped them understand the importance of proper waste disposal and recycling.
<br></br>
Montessori III children enthusiastically participated in a Seed Ball Making activity. Mixing soil, compost and seeds to create seed balls with great excitement. Through this hands-on experience, they understood how plants grow and how they can help make the Earth greener.

<br></br>
The celebration was an enjoyable learning experience that encouraged the children to develop environmental awareness and adopt eco-friendly habits from a young age.
<br></br>


        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Crafted by tiny hands, inspired by Mother Earth"

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EnvironmentDayCelebration2026;